export const DEFAULT_MODAL_DATA = {
  activeArtist: null,
  activeTrack: null,
  activeTopList: null,
  activePlaylistType: null,
  activePlaylistId: null,
  activeSuggestionPlaylist: null
};
